import { TubesPerRoll } from '../types/TubesPerRoll';
import { THREE_HUNDRED_BASE_TUBE_STORES } from '../constants/store/ThreeHundredBaseTubesStores';

export const DEFAULT_TUBES_PER_ROLL: TubesPerRoll = {
  onesPerRoll: 20,
  fivesPerRoll: 20,
  tensPerRoll: 10,
  twentiesPerRoll: 10,
  fiftiesPerRoll: 4,
  hundredsPerRoll: 2,
};

export const THREE_HUNDRED_BASE_TUBES_PER_ROLL: TubesPerRoll = {
  onesPerRoll: 20,
  fivesPerRoll: 20,
  tensPerRoll: 10,
  twentiesPerRoll: 15,
  fiftiesPerRoll: 6,
  hundredsPerRoll: 3,
};

export function getTubesPerRollForStore(
  storeId: number,
  date: string,
): TubesPerRoll {
  const storeConfig = THREE_HUNDRED_BASE_TUBE_STORES.find(({ storeIds }) =>
    storeIds.includes(storeId),
  );
  if (!storeConfig) {
    return DEFAULT_TUBES_PER_ROLL;
  }

  const { startDate, tubesPerRoleOverrides } = storeConfig;

  if (new Date(date).getTime() < startDate.getTime()) {
    return DEFAULT_TUBES_PER_ROLL;
  }
  return tubesPerRoleOverrides
    ? { ...THREE_HUNDRED_BASE_TUBES_PER_ROLL, ...tubesPerRoleOverrides }
    : THREE_HUNDRED_BASE_TUBES_PER_ROLL;
}
